<template>
  <div class="promotion_chart">
    <!--页面内容块中的加载动画-->
    <div class="loading_mask" v-show="loading">
      <div class="loading_anim">
        <img src="../../assets/img/loading-2.gif" />
      </div>
    </div>
    <div class="chart_bg_line"></div>
    <div class="left_chart">
      <!--下面的球队标签顺序不要随便移动，否则弹窗有可能部分区域会被覆盖-->
      <dl :class="riseMaps.t2_41_status == 2 ? 'fail_team' : ''" style="left: 3.3rem; top: 1.6rem">
        <dt>
          <img v-if="riseMaps.t2_41_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t2_41_name_logo != ''" :src="riseMaps.t2_41_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window">
            <div class="in_box">
              <div class="float_window_title_41"></div>
              <div class="date_time">
                {{ dateFormat(riseMaps.t1_t2_81_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.t1_81_name }}</div>
                  <div class="remark">1/4决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.t2_81_name }}</div>
                  <div class="remark">1/4决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <h3 class="yellow">第2场</h3>
          <p>{{ riseMaps.t2_41_name }}</p>
          <h3></h3>
        </dd>
      </dl>

      <dl style="left: 4.4rem; top: 2.75rem">
        <dt>
          <img v-if="riseMaps.t1_finals_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t1_finals_name_logo != ''" :src="riseMaps.t1_finals_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: -1.1rem">
            <div class="in_box">
              <div class="float_window_title_21"></div>
              <div class="date_time">
                {{ dateFormat(riseMaps.t2_t1_41_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.t1_41_name }}</div>
                  <div class="remark">第1场1/4决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.t2_41_name }}</div>
                  <div class="remark">第2场1/4决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <h3 class="yellow">第1场半决赛胜者</h3>
          <p>{{ riseMaps.t1_finals_name == "第1场半决赛胜者" ? "" : riseMaps.t1_finals_name }}</p>
          <h3></h3>
        </dd>
      </dl>

      <dl :class="riseMaps.t1_41_status == 2 ? 'fail_team' : ''" style="left: 3.3rem; top: 5.7rem">
        <dt>
          <img v-if="riseMaps.t1_41_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t1_41_name_logo != ''" :src="riseMaps.t1_41_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: -1.1rem">
            <div class="in_box">
              <div class="float_window_title_41"></div>
              <div class="date_time">
                {{ dateFormat(riseMaps.t5_t6_81_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.t5_81_name }}</div>
                  <div class="remark">1/4决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.t6_81_name }}</div>
                  <div class="remark">1/4决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>

          <h3></h3>
          <p>{{ riseMaps.t1_41_name }}</p>
          <h3 class="yellow">第1场</h3>
        </dd>
      </dl>

      <dl class="fail_team" style="left: 4.4rem; top: 4.08rem">
        <dt>
          <img v-if="riseMaps.t1_34_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t1_34_name_logo != ''" :src="riseMaps.t1_34_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: -0.9rem">
            <div class="in_box">
              <div class="float_window_title_21"></div>
              <div class="date_time">
                {{ dateFormat(riseMaps.t4_t3_41_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.t3_41_name }}</div>
                  <div class="remark">第3场1/4决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.t4_41_name }}</div>
                  <div class="remark">第4场1/4决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <h3 class="yellow">第1场半决赛败者</h3>
          <p>{{ riseMaps.t1_34_name == "第1场半决赛败者" ? "" : riseMaps.t1_34_name }}</p>
          <h3></h3>
        </dd>
      </dl>

      <dl :class="riseMaps.t1_81_status == 2 ? 'fail_team' : ''" style="left: 1.8rem; top: 0.55rem">
        <dt>
          <img v-if="riseMaps.t1_81_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t1_81_name_logo != ''" :src="riseMaps.t1_81_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window">
            <div class="in_box">
              <div class="date_time">
                {{ dateFormat(riseMaps.a1_b2_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.a1_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.b2_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>

          <!--下面是的三行标题文字-->
          <h3 class="yellow">第1场</h3>
          <p>{{ riseMaps.t1_81_name }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.t2_81_status == 2 ? 'fail_team' : ''" style="left: 1.8rem; top: 2.6rem">
        <dt>
          <img v-if="riseMaps.t2_81_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t2_81_name_logo != ''" :src="riseMaps.t2_81_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: -0.8rem">
            <div class="in_box">
              <div class="date_time">
                {{ dateFormat(riseMaps.c1_d2_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.c1_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.d2_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <h3></h3>
          <p>{{ riseMaps.t2_81_name }}</p>
          <h3 class="yellow">第2场</h3>
        </dd>
      </dl>

      <dl :class="riseMaps.t5_81_status == 2 ? 'fail_team' : ''" style="left: 1.8rem; top: 4.65rem">
        <dt>
          <img v-if="riseMaps.t5_81_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t5_81_name_logo != ''" :src="riseMaps.t5_81_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window">
            <div class="in_box">
              <div class="date_time">
                {{ dateFormat(riseMaps.e1_f2_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.e1_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.f2_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>

          <!--下面是的三行标题文字-->
          <h3 class="yellow">第5场</h3>
          <p>{{ riseMaps.t5_81_name }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.t6_81_status == 2 ? 'fail_team' : ''" style="left: 1.8rem; top: 6.7rem">
        <dt>
          <img v-if="riseMaps.t6_81_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t6_81_name_logo != ''" :src="riseMaps.t6_81_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: -0.8rem">
            <div class="in_box">
              <div class="date_time">
                {{ dateFormat(riseMaps.g1_h2_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.g1_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.h2_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <h3></h3>
          <p>{{ riseMaps.t6_81_name }}</p>
          <h3 class="yellow">第6场</h3>
        </dd>
      </dl>

      <dl :class="riseMaps.a1_status == 2 ? 'fail_team' : ''" style="left: 0.3rem; top: 0.1rem">
        <dt>
          <img v-if="riseMaps.a1_name_logo != ''" :src="riseMaps.a1_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3>A1</h3>
          <p>{{ riseMaps.a1_name != "A1" ? riseMaps.a1_name : "" }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.b2_status == 2 ? 'fail_team' : ''" style="left: 0.3rem; top: 1rem">
        <dt>
          <img v-if="riseMaps.b2_name_logo != ''" :src="riseMaps.b2_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3></h3>
          <p>{{ riseMaps.b2_name != "B2" ? riseMaps.b2_name : "" }}</p>
          <h3>B2</h3>
        </dd>
      </dl>

      <dl :class="riseMaps.c1_status == 2 ? 'fail_team' : ''" style="left: 0.3rem; top: 2.2rem">
        <dt>
          <img v-if="riseMaps.c1_name_logo != ''" :src="riseMaps.c1_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3>C1</h3>
          <p>{{ riseMaps.c1_name != "C1" ? riseMaps.c1_name : "" }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.d2_status == 2 ? 'fail_team' : ''" style="left: 0.3rem; top: 3rem">
        <dt>
          <img v-if="riseMaps.d2_name_logo != ''" :src="riseMaps.d2_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3></h3>
          <p>{{ riseMaps.d2_name != "D2" ? riseMaps.d2_name : "" }}</p>
          <h3>D2</h3>
        </dd>
      </dl>

      <dl :class="riseMaps.e1_status == 2 ? 'fail_team' : ''" style="left: 0.3rem; top: 4.2rem">
        <dt>
          <img v-if="riseMaps.e1_name_logo != ''" :src="riseMaps.e1_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3>E1</h3>
          <p>{{ riseMaps.e1_name != "E1" ? riseMaps.e1_name : "" }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.f2_status == 2 ? 'fail_team' : ''" style="left: 0.3rem; top: 5.1rem">
        <dt>
          <img v-if="riseMaps.f2_name_logo != ''" :src="riseMaps.f2_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3></h3>
          <p>{{ riseMaps.f2_name != "F2" ? riseMaps.f2_name : "" }}</p>
          <h3>F2</h3>
        </dd>
      </dl>

      <dl :class="riseMaps.g1_status == 2 ? 'fail_team' : ''" style="left: 0.3rem; top: 6.2rem">
        <dt>
          <img v-if="riseMaps.g1_name_logo != ''" :src="riseMaps.g1_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3>G1</h3>
          <p>{{ riseMaps.g1_name != "G1" ? riseMaps.g1_name : "" }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.h2_status == 2 ? 'fail_team' : ''" style="left: 0.3rem; top: 7.1rem">
        <dt>
          <img v-if="riseMaps.h2_name_logo != ''" :src="riseMaps.h2_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3></h3>
          <p>{{ riseMaps.h2_name != "H2" ? riseMaps.h2_name : "" }}</p>
          <h3>H2</h3>
        </dd>
      </dl>
    </div>

    <!--右侧部分-->
    <div class="right_chart">
      <dl :class="riseMaps.b1_status == 2 ? 'fail_team' : ''" style="right: 0.3rem; top: 0.1rem">
        <dt>
          <img v-if="riseMaps.b1_name_logo != ''" :src="riseMaps.b1_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3>B1</h3>
          <p>{{ riseMaps.b1_name != "B1" ? riseMaps.b1_name : "" }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.a2_status == 2 ? 'fail_team' : ''" style="right: 0.3rem; top: 1rem">
        <dt>
          <img v-if="riseMaps.a2_name_logo != ''" :src="riseMaps.a2_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3></h3>
          <p>{{ riseMaps.a2_name != "A2" ? riseMaps.a2_name : "" }}</p>
          <h3>A2</h3>
        </dd>
      </dl>

      <dl :class="riseMaps.d1_status == 2 ? 'fail_team' : ''" style="right: 0.3rem; top: 2.2rem">
        <dt>
          <img v-if="riseMaps.d1_name_logo != ''" :src="riseMaps.d1_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3>D1</h3>
          <p>{{ riseMaps.d1_name != "D1" ? riseMaps.d1_name : "" }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.c2_status == 2 ? 'fail_team' : ''" style="right: 0.3rem; top: 3rem">
        <dt>
          <img v-if="riseMaps.c2_name_logo != ''" :src="riseMaps.c2_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3></h3>
          <p>{{ riseMaps.c2_name != "C2" ? riseMaps.c2_name : "" }}</p>
          <h3>C2</h3>
        </dd>
      </dl>

      <dl :class="riseMaps.f1_status == 2 ? 'fail_team' : ''" style="right: 0.3rem; top: 4.2rem">
        <dt>
          <img v-if="riseMaps.f1_name_logo != ''" :src="riseMaps.f1_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3>F1</h3>
          <p>{{ riseMaps.f1_name != "F1" ? riseMaps.f1_name : "" }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.e2_status == 2 ? 'fail_team' : ''" style="right: 0.3rem; top: 5.1rem">
        <dt>
          <img v-if="riseMaps.e2_name_logo != ''" :src="riseMaps.e2_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3></h3>
          <p>{{ riseMaps.e2_name != "E2" ? riseMaps.e2_name : "" }}</p>
          <h3>E2</h3>
        </dd>
      </dl>

      <dl :class="riseMaps.h1_status == 2 ? 'fail_team' : ''" style="right: 0.3rem; top: 6.2rem">
        <dt>
          <img v-if="riseMaps.h1_name_logo != ''" :src="riseMaps.h1_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3>H1</h3>
          <p>{{ riseMaps.h1_name != "H1" ? riseMaps.h1_name : "" }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.g2_status == 2 ? 'fail_team' : ''" style="right: 0.3rem; top: 7.1rem">
        <dt>
          <img v-if="riseMaps.g2_name_logo != ''" :src="riseMaps.g2_name_logo" />
          <img v-else src="./img/not_country_flag.png" />
        </dt>
        <dd>
          <h3></h3>
          <p>{{ riseMaps.g2_name != "G2" ? riseMaps.g2_name : "" }}</p>
          <h3>G2</h3>
        </dd>
      </dl>

      <dl :class="riseMaps.t4_81_status == 2 ? 'fail_team' : ''" style="right: 1.8rem; top: 0.55rem">
        <dt>
          <img v-if="riseMaps.t4_81_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t4_81_name_logo != ''" :src="riseMaps.t4_81_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window">
            <div class="in_box">
              <div class="float_window_title_41"></div>
              <div class="date_time">
                {{ dateFormat(riseMaps.b1_a2_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.b1_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.a2_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>

          <!--下面是的三行标题文字-->
          <h3 class="yellow">第4场</h3>
          <p>{{ riseMaps.t4_81_name }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.t3_81_status == 2 ? 'fail_team' : ''" style="right: 1.8rem; top: 2.6rem">
        <dt>
          <img v-if="riseMaps.t3_81_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t3_81_name_logo != ''" :src="riseMaps.t3_81_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: -0.8rem">
            <div class="in_box">
              <div class="float_window_title_41"></div>
              <div class="date_time">
                {{ dateFormat(riseMaps.d1_c2_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.d1_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.c2_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <h3></h3>
          <p>{{ riseMaps.t3_81_name }}</p>
          <h3 class="yellow">第3场</h3>
        </dd>
      </dl>

      <dl :class="riseMaps.t7_81_status == 2 ? 'fail_team' : ''" style="right: 1.8rem; top: 4.65rem">
        <dt>
          <img v-if="riseMaps.t7_81_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t7_81_name_logo != ''" :src="riseMaps.t7_81_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window">
            <div class="in_box">
              <div class="date_time">
                {{ dateFormat(riseMaps.f1_e2_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.f1_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.e2_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <!--下面是的三行标题文字-->
          <h3 class="yellow">第7场</h3>
          <p>{{ riseMaps.t7_81_name }}</p>
          <h3></h3>
        </dd>
      </dl>
      <dl :class="riseMaps.t8_81_status == 2 ? 'fail_team' : ''" style="right: 1.8rem; top: 6.7rem">
        <dt>
          <img v-if="riseMaps.t8_81_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t8_81_name_logo != ''" :src="riseMaps.t8_81_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: -0.8rem">
            <div class="in_box">
              <div class="date_time">
                {{ dateFormat(riseMaps.h1_g2_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.h1_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.g2_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <h3></h3>
          <p>{{ riseMaps.t8_81_name }}</p>
          <h3 class="yellow">第8场</h3>
        </dd>
      </dl>

      <dl :class="riseMaps.t4_41_status == 2 ? 'fail_team' : ''" style="right: 3.3rem; top: 1.6rem">
        <dt>
          <img v-if="riseMaps.t4_41_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t4_41_name_logo != ''" :src="riseMaps.t4_41_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window">
            <div class="in_box">
              <div class="date_time">
                {{ dateFormat(riseMaps.t4_t3_81_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.t4_81_name }}</div>
                  <div class="remark">1/4决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.t3_81_name }}</div>
                  <div class="remark">1/4决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <h3 class="yellow">第4场</h3>
          <p>{{ riseMaps.t4_41_name }}</p>
          <h3></h3>
        </dd>
      </dl>

      <dl style="right: 4.4rem; top: 2.75rem">
        <dt>
          <img v-if="riseMaps.t2_finals_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t2_finals_name_logo != ''" :src="riseMaps.t2_finals_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: -1.1rem">
            <div class="in_box">
              <div class="float_window_title_21"></div>
              <div class="date_time">
                {{ dateFormat(riseMaps.t2_t1_41_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.t1_41_name }}</div>
                  <div class="remark">第1场1/4决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.t2_41_name }}</div>
                  <div class="remark">第2场1/4决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <h3 class="yellow">第2场半决赛胜者</h3>
          <p>{{ riseMaps.t2_finals_name == "第2场半决赛胜者" ? "" : riseMaps.t2_finals_name }}</p>
          <h3></h3>
        </dd>
      </dl>

      <dl class="fail_team" style="right: 4.4rem; top: 4.08rem">
        <dt>
          <img v-if="riseMaps.t2_34_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t2_34_name_logo != ''" :src="riseMaps.t2_34_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: -1.1rem">
            <div class="in_box">
              <div class="float_window_title_21"></div>
              <div class="date_time">
                {{ dateFormat(riseMaps.t4_t3_41_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.t3_41_name }}</div>
                  <div class="remark">第3场1/4决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.t4_41_name }}</div>
                  <div class="remark">第4场1/4决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <h3 class="yellow">第2场半决赛败者</h3>
          <p>{{ riseMaps.t2_34_name == "第2场半决赛败者" ? "" : riseMaps.t2_34_name }}</p>
          <h3></h3>
        </dd>
      </dl>

      <dl :class="riseMaps.t3_41_status == 2 ? 'fail_team' : ''" style="right: 3.3rem; top: 5.7rem">
        <dt>
          <img v-if="riseMaps.t3_41_name_logo == ''" src="./img/not_country_flag.png" />
          <img v-if="riseMaps.t3_41_name_logo != ''" :src="riseMaps.t3_41_name_logo" />
        </dt>
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: -0.8rem">
            <div class="in_box">
              <div class="date_time">
                {{ dateFormat(riseMaps.t7_t8_81_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.t7_81_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.t8_81_name }}</div>
                  <div class="remark">1/8决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>

          <h3></h3>
          <p>{{ riseMaps.t3_41_name }}</p>
          <h3 class="yellow">第3场</h3>
        </dd>
      </dl>

      <dl style="right: 6rem; top: 2.75rem">
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: -0.9rem">
            <div class="in_box">
              <div class="float_window_title_finals"></div>
              <div class="date_time">
                {{ dateFormat(riseMaps.t1_t2_finals_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.t1_finals_name }}</div>
                  <div class="remark">第1场半决赛胜者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.t2_finals_name }}</div>
                  <div class="remark">第2场半决赛胜者</div>
                </div>
              </div>
            </div>
            <span class="bottom_arrow"></span>
          </div>
          <h3></h3>
          <p style="border-radius: 0.3rem">决赛</p>
          <h3></h3>
        </dd>
      </dl>
      <dl style="right: 6rem; top: 4.08rem">
        <dd>
          <!--当鼠标滑过时的提示弹窗-->
          <div class="chart_float_window" style="top: 0.6rem">
            <div class="in_box">
              <div class="float_window_title_finals_34"></div>
              <span class="top_arrow"></span>
              <div class="date_time">
                {{ dateFormat(riseMaps.t1_t2_34_match_time * 1000, "MM月dd日 hh:mm") }}
              </div>
              <div class="compare_content">
                <div class="team_left">
                  <div class="name">{{ riseMaps.t1_34_name }}</div>
                  <div class="remark">第1场半决赛败者</div>
                </div>
                <span class="icon"><img src="./img/icon_compare.png" /></span>
                <div class="team_right">
                  <div class="name">{{ riseMaps.t2_34_name }}</div>
                  <div class="remark">第2场半决赛败者</div>
                </div>
              </div>
            </div>
          </div>
          <h3></h3>
          <p style="border-radius: 0.3rem">三四名决赛</p>
          <h3></h3>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { post } from "@/util/http";
import { format } from "@/util/time";

export default {
  name: "riseMap",
  data() {
    return {
      //页面上的内容块加载动画
      loading: false,
      //晋级图数据
      riseMaps: [],
      //定义日期函数的处理方法
      dateFormat: format,
    };
  },
  methods: {
    /**
     * 获取晋级图所需要的数据
     */
    getRiseMap() {
      this.loading = true;
      post({
        url: "/api/sport/world_cup_team_rank",
      })
        .then((res) => {
          if (res.status === 200 && res.data.status === 0) {
            let new_data = res.data.data;
            if (new_data == null) {
              this.riseMaps = [];
            } else {
              this.riseMaps = new_data;
            }
            // console.log("晋级图数据：", this.riseMaps);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
//世界杯晋级图
.promotion_chart {
  clear: both;
  width: 100%;
  height: 8rem;
  background: url(./img/bg_jinji.png) no-repeat top center;
  background-size: 100%;
  box-sizing: border-box;
  padding: 0.55rem;
  border-radius: 0.1rem;
  position: relative;

  .chart_bg_line {
    clear: both;
    width: 100%;
    height: 100%;
    background: url(./img/bg_jinji_line.png) no-repeat top center;
    background-size: auto 100%;
  }

  .left_chart,
  .right_chart {
    float: left;
    width: 45%;
    height: 100%;
    box-sizing: border-box;
    position: absolute;
    z-index: 10;
    left: 0;
    top: 0;

    dl {
      display: flex;
      justify-content: space-around;
      width: auto;
      height: 0.72rem;
      box-sizing: border-box;
      padding-left: 0.4rem;
      position: absolute;
      z-index: 5;

      &:hover .chart_float_window {
        display: block;
      }

      dt {
        width: 0.5rem;
        height: 0.5rem;
        overflow: hidden;
        border-radius: 0.5rem;
        background-color: #fff;
        position: absolute;
        z-index: 2;
        left: 0;
        top: 0.11rem;

        img {
          display: block;
          height: 100%;
          margin: 0 auto;
        }
      }

      dd {
        display: flex;
        flex-direction: column;
        justify-content: center;
        clear: both;
        width: 100%;
        height: 100%;
        position: relative;

        h3,
        p {
          display: block;
          clear: both;
          width: 1.2rem;
          height: 0.24rem;
          line-height: 0.24rem;
          overflow: hidden;
          box-sizing: border-box;
          padding: 0px 0.1rem;
          padding-left: 0.2rem;
          white-space: nowrap;
          word-break: break-all;
          text-overflow: ellipsis;
          font-size: 0.16rem;
          font-weight: 500;
          color: #fff;
          text-align: center;
        }

        h3 {
          font-family: "Arial";
        }

        h3.yellow {
          font-weight: 400;
          color: #ffba39;
        }

        p {
          background-color: #a8032b;
          border-top-right-radius: 0.1rem;
        }

        //当鼠标滑过时的提示弹窗
        .chart_float_window {
          display: none;
          clear: both;
          width: auto;
          min-width: 2.2rem;
          height: 1rem;
          background: linear-gradient(to right, #ff0054, #ffc700);
          box-sizing: border-box;
          padding: 2px;
          border-radius: 15px;
          position: absolute;
          z-index: 100;
          left: 0.2rem;
          top: -1.1rem;
          box-shadow: 0px 0px 8px #ff6095;
          -webkit-box-shadow: 0px 0px 8px #ff6095;
          -moz-box-shadow: 0px 0px 8px #ff6095;
          -o-box-shadow: 0px 0px 8px #ff6095;
          -ms-box-shadow: 0px 0px 8px #ff6095;

          .in_box {
            clear: both;
            width: 100%;
            height: 100%;
            background: url(./img/float_window_bg.png) no-repeat top center;
            background-size: 100%;
            background-color: #fff;
            box-sizing: border-box;
            border-radius: 13px;
            padding: 0.1rem;
            position: relative;
            z-index: 5;

            .float_window_title_finals,
            .float_window_title_finals_34,
            .float_window_title_21,
            .float_window_title_41 {
              display: block;
              clear: both;
              width: 1.14rem;
              height: 0.25rem;
              overflow: hidden;
              background-repeat: no-repeat;
              background-position: top center;
              background-size: auto 100%;
              margin: 0 auto;
              position: absolute;
              z-index: 5;
              top: -7px;
              left: 0;
              right: 0;
            }
            .float_window_title_finals {
              background-image: url("./img/float_window_title_finals.png");
            }
            .float_window_title_finals_34 {
              background-image: url("./img/float_window_title_finals_34.png");
            }
            .float_window_title_21 {
              background-image: url("./img/float_window_title_21.png");
              top: -5px;
            }
            .float_window_title_41 {
              background-image: url("./img/float_window_title_41.png");
            }

            .date_time {
              clear: both;
              width: 100%;
              height: 0.35rem;
              line-height: 0.35rem;
              overflow: hidden;
              font-size: 0.14rem;
              color: #666;
              text-align: center;
            }

            .compare_content {
              display: flex;
              justify-content: center;
              clear: both;
              width: 100%;
              height: 100%;
              overflow: hidden;

              .icon {
                flex-shrink: 0;
                display: block;
                width: 0.3rem;
                height: auto;
                overflow: hidden;
                padding: 0px 0.1rem;

                img {
                  display: block;
                  width: 100%;
                }
              }

              .team_left,
              .team_right {
                float: left;
                width: 100%;
                height: 100%;
                overflow: hidden;

                .name,
                .remark {
                  clear: both;
                  width: 100%;
                  min-width: 0.8rem;
                  height: 0.2rem;
                  line-height: 0.2rem;
                  overflow: hidden;
                  white-space: nowrap;
                  word-break: break-all;
                  text-overflow: ellipsis;
                  font-size: 0.1rem;
                  color: #ff9900;
                  text-align: center;
                }

                .name {
                  font-family: "PingFang SC";
                  font-size: 0.16rem;
                  font-weight: 500;
                  color: #333;
                }
              }
            }
          }

          .bottom_arrow,
          .top_arrow {
            display: block;
            clear: both;
            width: 30px;
            height: 40px;
            overflow: hidden;
            background: url("./img/float_window_arrow.png") no-repeat top left;
            background-size: 100%;
            position: absolute;
            z-index: 2;
            left: 20px;
            bottom: -35px;
          }
          .top_arrow {
            background: url("./img/float_window_arrow_top.png") no-repeat top left;
            background-size: 100%;
            top: -19px;
          }
        }
      }

      //失败的球队，变成灰色
      //与产品沟通了，灰色不要启用
      // &.fail_team {
      //     dt {
      //         img {
      //             -webkit-filter: grayscale(100%);
      //             filter: grayscale(100%);
      //         }
      //     }

      //     dd {
      //         p {
      //             background-color: #929292;
      //             color: rgba(255, 255, 255, 0.5);
      //         }
      //     }
      // }
    }
  }

  .right_chart {
    float: right;
    width: 55%;
    left: auto;
    right: 0;
    z-index: 5;

    dl {
      padding-right: 0.4rem;

      dt {
        left: auto;
        right: 0;
      }

      dd {
        p {
          border-top-right-radius: 0;
          border-top-left-radius: 0.1rem;
          padding-left: 0.1rem;
          padding-right: 0.2rem;
        }
      }
    }
  }
}
</style>